import {
  SeedCrop,
  SeedCropDTO,
  SeedCropListRequestFilter,
  SeedCropListRequestSorting,
} from 'modules/domain/seedCrop/types'
import { apiClient } from 'modules/utils/httpClient'
import { endpoints } from 'modules/endpoints'
import { ListResponse } from 'types/api'

export const getSeedCropsList = (
  filter: SeedCropListRequestFilter,
  sorting: SeedCropListRequestSorting,
  page: number,
  pageSize?: number,
) => {
  try {
    return apiClient.get<ListResponse<SeedCrop>>(endpoints.seedCrop(), {
      ...filter,
      ...sorting,
      page: page,
      page_size: pageSize,
    })
  } catch (err) {
    console.error('Seed crops list fetch error!', err)
    throw err
  }
}

export const getSeedCrop = (id: string) => {
  try {
    return apiClient.get<SeedCrop>(endpoints.seedCrop(id))
  } catch (err) {
    console.error('Seed crop fetch error!', err)
    throw err
  }
}

export const addSeedCrop = (seedCrop: SeedCropDTO) => {
  try {
    return apiClient.post<SeedCrop>(endpoints.seedCrop(), seedCrop)
  } catch (err) {
    console.error('Seed crop create error!', err)
    throw err
  }
}

export const updateSeedCrop = (id: string, seedCrop: SeedCropDTO) => {
  return apiClient.put<SeedCrop>(endpoints.seedCrop(id), seedCrop)
}

export const removeSeedCrop = (id: string) => {
  return apiClient.delete(endpoints.seedCrop(id))
}
